import {Command} from '@application/command/command';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {PlanningMachineCarpetRun} from '@domain/planning/carpet/planning-machine-carpet-run';
import {PlanningMachineRun} from '@domain/planning/planning-machine-run';
import {PlanningMachineTuftingRun} from '@domain/planning/tufting/planning-machine-tufting-run';
import {PlanningMachineWeavingRun} from '@domain/planning/weaving/planning-machine-weaving-run';
import {find} from 'lodash-es';
import {AddNewPlanningItemCommand} from '../add-new-planning-item/add-new-planning-item-command';
import {RemovePlanningOrderCommand} from '../remove-planning-order/remove-planning-order-command';
import {AddPlannedPlanningOrderToNewRunParameters} from './add-planned-order-to-new-run-parameters';

export class AddPlannedOrderToNewRunCommand implements Command<AddPlannedPlanningOrderToNewRunParameters, CalendarItemGroup[]> {
  private readonly addNewPlanningItemCommand = new AddNewPlanningItemCommand();
  private readonly removePlanningOrderCommand = new RemovePlanningOrderCommand();

  public execute(commandArgs: AddPlannedPlanningOrderToNewRunParameters): CalendarItemGroup[] {
    const {plannedPlanningOrder, destinationMachine, sourceRun, sourceMachineId} = commandArgs;
    let {groupedCalendarItems} = commandArgs;
    let newRun: PlanningMachineRun;
    if (sourceRun instanceof PlanningMachineCarpetRun) {
      newRun = new PlanningMachineCarpetRun(null, sourceRun.machineQuality, sourceRun.creel, [plannedPlanningOrder], plannedPlanningOrder.startDate, plannedPlanningOrder.endDate, true);
    } else if (sourceRun instanceof PlanningMachineWeavingRun) {
      newRun = new PlanningMachineWeavingRun(null, sourceRun.weaveProduct, [plannedPlanningOrder], plannedPlanningOrder.startDate, plannedPlanningOrder.endDate, true);
    } else if (sourceRun instanceof PlanningMachineTuftingRun) {
      newRun = new PlanningMachineTuftingRun(null, sourceRun.tuftProduct, [plannedPlanningOrder], plannedPlanningOrder.startDate, plannedPlanningOrder.endDate, true);
    }

    const sourceGroupedCalendarItem = find(groupedCalendarItems, {machineId: sourceMachineId});

    groupedCalendarItems = this.removePlanningOrderCommand.execute({
      sourceGroupedCalendarItem,
      groupedCalendarItems,
      planningOrder: plannedPlanningOrder,
      run: sourceRun,
      adjustRunRunningTime: true
    });

    const destinationGroupedCalendarItem = find(groupedCalendarItems, {machineId: destinationMachine.id});

    return this.addNewPlanningItemCommand.execute({newPlanningItem: newRun, destinationGroupedCalendarItem, groupedCalendarItems});
  }
}
